import { produce } from 'immer';
import { AnyAction } from 'redux';

import { MessageResponse } from '../../../_helpers/iResponse';
import { IService } from '../../serviceOrdering/reducers';
import { GET_DASHBOARD_INFO_SUCCESS } from '../constants';

export interface IDashboard {
  services: IService[];
  histories: History[];
  countServicesDone: string;
  countServicesIncoming: string;
}

export interface History {
  text: string;
  createdAt: string;
  action: string;
}

export interface IResponseDashboard {
  error: string;
  data: {
    data: IDashboard;
    message: MessageResponse;
  };
}

const initState = {
  services: [],
  histories: [],
  countServicesDone: '0',
  countServicesIncoming: '0'
};

const dashboardReducer = produce((draft = initState, action: AnyAction) => {
  switch (action.type) {
    case GET_DASHBOARD_INFO_SUCCESS:
      draft.services = action.payload.services;
      draft.histories = action.payload.histories;
      draft.countServicesDone = action.payload.countServicesDone;
      draft.countServicesIncoming = action.payload.countServicesIncoming;
      break;
    default:
      return draft;
  }
});

export default dashboardReducer;
